/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import moment from "moment";
import React from "react";
import _ from "lodash";

// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";
import totalImage from "../../assets/images/total.jpg";
import IdleImage from "../../assets/images/idle.jpg";
import parkingImage from "../../assets/images/parking.jpg";
import movingImage from "../../assets/images/moving.jpg";
import connectedImage from "../../assets/images/connected.jpg";
import disconnectedImage from "../../assets/images/disconnected.png";

class Header extends React.Component {
  vehicleStatus(row) {
    let status = "";
    const ont = parseInt(row.ont);
    const oft = parseInt(row.oft);
    const spd = parseInt(row.spd);
    if (oft !== 0 && spd === 0) {
      status = "Parked";
    } else if (ont !== 0 && spd === 0) {
      status = "Idle";
    } else if (ont !== 0 && spd !== 0) {
      status = "Moving";
    } else {
      status = "Others";
    }
    return status;
  }

  deviceStatus(row) {
    const incomeTimeStamp = moment.unix(parseInt(row.tsp));
    const currentTimeStamp15MinutesLess = moment(Date()).subtract(
      15,
      "minutes"
    );
    const deviceStatus = incomeTimeStamp.isAfter(currentTimeStamp15MinutesLess);
    return deviceStatus ? "ON" : "OFF";
  }

  handleCardDisplayLogicForDeviceOnOrOff(dashboardData) {
    let temp = [];
    dashboardData.forEach((element, index) => {
      const tempElement = { id: index, name: this.deviceStatus(element) };
      temp.push(tempElement);
    });
    const cardList = _(temp)
      .groupBy("name")
      .values()
      .map((group) => ({ ...group[0], qty: group.length }));
    return cardList;
  }

  handleCardDisplayLogic(dashboardData) {
    let temp = [];
    dashboardData.forEach((element, index) => {
      const tempElement = { id: index, name: this.vehicleStatus(element) };
      temp.push(tempElement);
    });
    const cardList = _(temp)
      .groupBy("name")
      .values()
      .map((group) => ({ ...group[0], qty: group.length }));
    return cardList;
  }

  retriveImage(name) {
    let urlName;
    if (name === "Parked") {
      urlName = parkingImage;
    } else if (name === "Idle") {
      urlName = IdleImage;
    } else if (name === "Moving") {
      urlName = movingImage;
    } else if (name === "ON") {
      urlName = connectedImage;
    } else if (name === "OFF") {
      urlName = disconnectedImage;
    } else {
      urlName = totalImage;
    }
    return `url(${urlName})`;
  }
  render() {
    const { dashboardData } = this.props;
    const cardList = [
      ...this.handleCardDisplayLogic(dashboardData),
      ...this.handleCardDisplayLogicForDeviceOnOrOff(dashboardData),
    ];
    return (
      <>
        <div className="header bg-gradient-info pb-5 pt-5 pt-md-8">
          <Container fluid>
            <div className="header-body">
              {/* Card stats */}
              <Row>
                <Col lg="6" xl="3">
                  <Card className="card-stats mb-4 mb-xl-0">
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                            All
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                            <b>{dashboardData.length}</b>
                          </span>
                        </div>
                        <Col className="col-auto">
                          <div
                            className="icon icon-shape bg-danger text-white rounded-circle shadow"
                            style={{
                              backgroundImage: `url(${totalImage})`,
                              backgroundSize: "cover",
                              color: "white",
                            }}
                          ></div>
                        </Col>
                      </Row>
                      {/* <p className="mt-3 mb-0 text-muted text-sm">
                        <span className="text-success mr-2">
                          <i className="fa fa-arrow-up" /> 3.48%
                        </span>{" "}
                        <span className="text-nowrap">Since last month</span>
                      </p> */}
                    </CardBody>
                  </Card>
                </Col>
                {cardList.map((card) => (
                  <Col lg="6" xl="3">
                    <Card className="card-stats mb-4 mb-xl-0">
                      <CardBody>
                        <Row>
                          <div className="col">
                            <CardTitle
                              tag="h5"
                              className="text-uppercase text-muted mb-0"
                            >
                              {card.name}
                            </CardTitle>
                            <span className="h2 font-weight-bold mb-0">
                              {card.qty}
                            </span>
                          </div>
                          <Col className="col-auto">
                            <div
                              className="icon icon-shape bg-danger text-white rounded-circle shadow"
                              style={{
                                backgroundImage: this.retriveImage(card.name),
                                backgroundSize: "cover",
                                color: "white",
                              }}
                            ></div>
                          </Col>
                        </Row>
                       {/*  <p className="mt-3 mb-0 text-muted text-sm">
                          <span className="text-success mr-2">
                            <i className="fa fa-arrow-up" /> 3.48%
                          </span>{" "}
                          <span className="text-nowrap">Since last month</span>
                        </p> */}
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default Header;
